/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface NoticeWhatsNewPayload {
    isMobile?: boolean;
}

export interface WhatsNewListItem {
    careerId: string;
    careerTypeId: number;
    classId: string;
    isBtnApply: number;
    isBtnResultApply: number;
    messageId: string;
    messageList: Array<string>;
    startDateStr: string;
    titleList: Array<string>;
}

export interface NoticeWhatsNewResponse {
    whatsNewList: WhatsNewListItem[];
}

class NoticeWhatsNewService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "noticeWhatsNew");
    }

    public async noticeWhatsNew(payload: NoticeWhatsNewPayload, resolved: (json: NoticeWhatsNewResponse) => void, rejected: (error: any) => void) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as NoticeWhatsNewResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default NoticeWhatsNewService;
